<template>
  <section class="kws-quiz-introduction" v-bind="parseAttributeString">
    <div class="kws-quiz-text-wrapper">
      <h2 class="h2">{{ headline }}</h2>
      <first-spirit-image
        v-if="img && img.sm"
        class="kws-quiz-img-mobile"
        :fs-cc-attrs="img.fsCcAttrs"
        :alt="img.alt"
        :src="img.sm.src"
        :srcset="img.sm.srcset"
        :sizes="img.sm.sizes"
      ></first-spirit-image>
      <div class="kws-quiz-text-content">
        <p class="">{{ text }}</p>
        <button
          @click="startQuiz"
          class="button button--medium button--primary"
        >{{ translate('btnStart') }}</button>
      </div>
    </div>
    <div class="kws-quiz-img-desktop">
      <first-spirit-image
        v-if="img && img.lg"
        class="kws-quiz-img-desktop"
        :fs-cc-attrs="img.fsCcAttrs"
        :alt="img.alt"
        :src="img.lg.src"
        :srcset="img.lg.srcset"
        :sizes="img.lg.sizes"
      ></first-spirit-image>
    </div>
  </section>
</template>

<script>
import FirstSpiritContentCreatorMixin from '../../shared/mixins/FirstSpiritContentCreatorMixin';
import FirstSpiritImage from './fs-image.vue';

export default {
  mixins: [FirstSpiritContentCreatorMixin],
  components: {
    FirstSpiritImage,
  },
  props: {
    headline: String,
    text: String,
    img: Object,
  },
  methods: {
    startQuiz() {
      this.$emit('start');
    },
  },
};
</script>

<style lang="scss">
.kws-quiz-introduction {
  h2 {
    &::after {
      .theme-sugarbeet &,
      .theme-sorghum &,
      .theme-grains-pea &,
      .theme-rape-seed & {
        background-color: $color-white;
      }
    }
  }
}
</style>
